module.exports = __webpack_public_path__ + "img/poster_grand_tour.302c1d84.png";